const cmsUrl = process.env.CMS_URL;
const host = process.env.BACKEND_URL;

const getData = async (url, isCms = true) => {
  const baseUrl = isCms ? cmsUrl : host;
  try {
    const response = await fetch(`${baseUrl}${url}`);
    if (response.ok) {
      const json = await response.json();
      return json;
    }
  } catch (error) {
    return error;
  }
};

export default getData;
